var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_729_993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.09703 4.26482C1.27318 2.61836 2.59741 1.29412 4.24307 1.11069C5.46542 0.974441 6.72046 0.857422 8.00003 0.857422C9.27961 0.857422 10.5347 0.974441 11.7569 1.11069C13.4027 1.29412 14.7269 2.61836 14.903 4.26482C15.0331 5.48026 15.1429 6.72811 15.1429 8.00028C15.1429 9.27246 15.0331 10.5203 14.903 11.7357C14.7269 13.3822 13.4027 14.7065 11.7569 14.8899C10.5347 15.0261 9.27961 15.1431 8.00003 15.1431C6.72046 15.1431 5.46542 15.0261 4.24307 14.8899C2.59741 14.7065 1.27318 13.3822 1.09703 11.7357C0.966987 10.5203 0.857178 9.27246 0.857178 8.00028C0.857178 6.72811 0.966988 5.48026 1.09703 4.26482Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.2174V4.7832",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6915 7.09307C9.87368 6.05981 9.31667 5.57897 8.48659 4.95009C8.19288 4.72757 7.80755 4.72757 7.51383 4.95009C6.68375 5.57897 6.12674 6.05981 5.30896 7.09308",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_729_993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.014ef1a2bf9c0df7fa7e5f697123a998.svg";
export { ForwardRef as ReactComponent };